import { mergeClasses } from '@fluentui/react-components';
import React, { FunctionComponent } from 'react';

export interface IScopeBarLeftContentProps {
  className?: string;
  children: React.ReactNode;
}

export const ScopeBarLeftContent: FunctionComponent<IScopeBarLeftContentProps> = ({ className, children, ...rest }) => (
  <div className={mergeClasses('scope-bar-left-content', className)}>
    {React.Children.map(children, (child) => child && React.isValidElement(child) && React.cloneElement(child, { ...rest }))}
  </div>
);

ScopeBarLeftContent.defaultProps = {
  className: '',
};
